/**
 * The app's one axios instance, published as `http` from `@/shared/api`. **Do not create a
 * second one** — everything the rest of the code assumes about a request lives on this object.
 *
 * It carries the base URL, the session cookie, the request timeout, the param serializer and
 * the interceptors — so a request made through it behaves the way `interceptors.ts` and
 * `params.ts` describe, and one made through a fresh instance does not.
 */

import axios from 'axios'
import { setupInterceptors } from './interceptors'
import { serializeParams } from './params'

export const http = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
  timeout: 15000,
  withCredentials: true,
  paramsSerializer: { serialize: serializeParams }
})

setupInterceptors(http)
